import {jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import NotificationTemplate from './NotificationTemplate'





const KickedOut = (props) => {
  const {notification: notificationRef} = props
  const notification = useFragment(
    graphql`
      fragment KickedOut_notification on NotifyKickedOut {
        ...NotificationTemplate_notification
        evictor {
          picture
          preferredName
        }
        team {
          name
        }
      }
    `,
    notificationRef
  )
  const {team, evictor} = notification
  const {name: teamName} = team
  const {preferredName: evictorName, picture: evictorPicture} = evictor
  return (
    _jsx(NotificationTemplate, {
      avatar: evictorPicture,
      message: `${evictorName} removed you from the ${teamName} team`,
      notification: notification,}
    )
  )
}

export default KickedOut
